import "@/styles/theme.scss";
import "@/styles/index.css";
// do not import, as js code (e.g. dropdown) does not work otherwise
// import "bootstrap/dist/js/bootstrap";

import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { router, startGlobalDateTimeTimer } from "@/services";
import i18n from "./i18n";
import Vue3Toasity, { type ToastContainerOptions } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Typeahead from "@/components/TypeaheadComponent.vue";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import duration from 'dayjs/plugin/duration';
import 'dayjs/locale/de';
import 'dayjs/locale/fr';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);

dayjs.locale('de');

const localeEnSince = {
  ...dayjs.Ls['en'], // copy the existing locale
  relativeTime: {
    ...dayjs.Ls['en']!.relativeTime,
    past: 'since %s' // only change the past string
  }
};
const localeDeSince = {
  ...dayjs.Ls['de'], // copy the existing locale
  relativeTime: {
    ...dayjs.Ls['de']!.relativeTime,
    past: 'seit %s' // only change the past string
  }
};
const localeFrSince = {
  ...dayjs.Ls['fr'], // copy the existing locale
  relativeTime: {
    ...dayjs.Ls['fr']!.relativeTime,
    past: 'depuis %s' // only change the past string
  }
};

// register the locale globally
dayjs.locale('en-since', localeEnSince);
dayjs.locale('de-since', localeDeSince);
dayjs.locale('fr-since', localeFrSince);

// Start the global date-time timer
startGlobalDateTimeTimer();

function onScan(scanEvent: ScanEvent) {
  const scanData = scanEvent.data;
  const scanType = scanEvent.type;
  if (scanData && scanData.length > 0) {
    const onScanEvent = new CustomEvent("onScan", {
      detail: {
        type: scanType,
        data: scanData,
      },
    });
    window.dispatchEvent(onScanEvent);
  }
}

// TODO: remove this when the window.onScan is declared in the global scope
declare const window: Window &
  typeof globalThis & { onScan: (scanEvent: ScanEvent) => void };

window.onScan = onScan;

// translations

// import the fontawesome core
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from "@fortawesome/vue-fontawesome";

import { all } from "@awesome.me/kit-16860fb9af/icons";

library.add(...all);

import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

// get the app running
const app = createApp(App);

app.config.globalProperties.$dayjs = dayjs;

app
  .use(createPinia())
  .use(i18n)
  .use(router)
  .use(Vue3Toasity, {
    position: "top-right",
  } as ToastContainerOptions)
  .directive("focus", {
    mounted(el) {
      el.focus();
    },
  })
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("font-awesome-layers", FontAwesomeLayers)
  .component("font-awesome-layers-text", FontAwesomeLayersText)
  .component("Typeahead", Typeahead)
  .component('VueDatePicker', VueDatePicker)
  .directive("uppercase", {
    beforeUpdate(el) {
      if (el.value && typeof el.value === "string") {
        el.value = el.value.toUpperCase();
      }
    },
  });
app.mount("#app");
